import { __assign, __extends, __rest } from "tslib";
import { Shape } from '../types';
import { DisplayObject } from './DisplayObject';

var Rect =
/** @class */
function (_super) {
  __extends(Rect, _super);

  function Rect(_a) {
    if (_a === void 0) {
      _a = {};
    }

    var style = _a.style,
        rest = __rest(_a, ["style"]);

    return _super.call(this, __assign({
      type: Shape.RECT,
      style: __assign({
        width: 'auto',
        height: 'auto',
        lineWidth: 0
      }, style)
    }, rest)) || this;
  }

  return Rect;
}(DisplayObject);

export { Rect };